'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var getClientStorage = _interopDefault(require('@narvar/client-storage'));

(function (StorageType) {
  StorageType["SESSION_STORAGE"] = "sessionStorage";
  StorageType["LOCAL_STORAGE"] = "localStorage";
})(exports.StorageType || (exports.StorageType = {}));
(function (Keyspace) {
  Keyspace["GUID"] = "guid";
  Keyspace["REQUEST_UUID"] = "request_uuid";
})(exports.Keyspace || (exports.Keyspace = {}));
var ONE_DAY_MS = 24 * 60 * 60 * 1000;
var NARVARJS_NAMESPACE = 'narvarjs';
var NAMESPACE_SEPERATOR = ':';
var clientStorageDisabled = !getClientStorage();
var inMemoryGuid;
var Storage = (function () {
  var storageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.StorageType.LOCAL_STORAGE;
  var keySpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.Keyspace.GUID;
  var storage = Object.freeze({
    get: function get(errorCallback) {
      if (clientStorageDisabled && inMemoryGuid) return inMemoryGuid;
      try {
        var unparsedData = window[storageType].getItem([NARVARJS_NAMESPACE, keySpace].join(NAMESPACE_SEPERATOR));
        if (!unparsedData) return null;
        inMemoryGuid = JSON.parse(unparsedData);
        return inMemoryGuid;
      } catch (err) {
        errorCallback(err);
        return null;
      }
    },
    set: function set(data, errorCallback) {
      inMemoryGuid = data;
      try {
        window[storageType].setItem([NARVARJS_NAMESPACE, keySpace].join(NAMESPACE_SEPERATOR), JSON.stringify(data));
      } catch (err) {
        errorCallback(err);
      }
    },
    isExpired: function isExpired(errorCallback) {
      var _ref = storage.get(errorCallback) || {},
        _ref$dateCreated = _ref.dateCreated,
        dateCreated = _ref$dateCreated === void 0 ? null : _ref$dateCreated;
      return dateCreated ? Date.now() - new Date(dateCreated.toString()).getTime() > ONE_DAY_MS : true;
    },
    isEmpty: function isEmpty(errorCallback) {
      return !storage.get(errorCallback);
    }
  });
  return storage;
});

exports.default = Storage;
